class AudioPlayer {
  static instance = null;
  static isClosed = false;

  static getInstance(src) {
    if (!AudioPlayer.instance || AudioPlayer.isClosed) {
      AudioPlayer.instance = new AudioPlayer(src);
      AudioPlayer.isClosed = false;
    } else {
      // Si on a déjà une instance, on la met à jour avec la nouvelle source
      AudioPlayer.instance.updateSource(src);
    }
    return AudioPlayer.instance;
  }

  static resetInstance() {
    if (AudioPlayer.instance) {
      // Nettoyer l'ancienne instance
      if (AudioPlayer.instance.audio) {
        AudioPlayer.instance.audio.pause();
        AudioPlayer.instance.audio.currentTime = 0;
      }
      if (AudioPlayer.instance.audioCtx && AudioPlayer.instance.audioCtx.state !== 'closed') {
        AudioPlayer.instance.audioCtx.close();
      }

      // Nettoyer tous les événements
      AudioPlayer.instance.removeAllEvents();

      // Gérer les classes CSS pour l'animation de fermeture
      if (AudioPlayer.instance.el) {
        AudioPlayer.instance.el.classList.add('animate-out');
        AudioPlayer.instance.el.classList.remove('is-visible');
        
        // Supprimer les classes après l'animation
        const onTransitionEnd = () => {
          AudioPlayer.instance.el.classList.remove('animate-out');
          AudioPlayer.instance.el.removeEventListener('transitionend', onTransitionEnd);
        };
        AudioPlayer.instance.el.addEventListener('transitionend', onTransitionEnd);
      }

      AudioPlayer.instance = null;
      AudioPlayer.isClosed = true;
    }
  }

  constructor(src) {
    if (AudioPlayer.instance) {
      return AudioPlayer.instance;
    }
    this.src = src;
    this.initialize();
    AudioPlayer.instance = this;
  }

  updateSource(src) {
    try {
      // Nettoyer l'ancien audio
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
      }
      
      // Mettre à jour la source
      this.src = src;
      this.audio = new Audio(src);
      
      // Réinitialiser les connexions audio
      if (this.track) {
        this.track.disconnect();
      }
      this.track = this.audioCtx.createMediaElementSource(this.audio);
      this.track.connect(this.audioCtx.destination);
      
      // Réinitialiser l'état
      this.playing = false;
      this.onPause();

      // Réinitialiser les événements
      this.removeAllEvents();
      this.bindEvents();
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la source audio:', error);
    }
  }

  initialize() {
    this.el = document.querySelector('.js-player')
    // this.src = this.el.getAttribute('data-audio')
    this.audio = new Audio(this.src)
    this.playing = false
    let AudioContext = window.AudioContext          // Default
              || window.webkitAudioContext;  // Safari and old versions of Chrome
    this.audioCtx = new AudioContext()
    this.gainNode = this.audioCtx.createGain()
    this.analyserNode = this.audioCtx.createAnalyser()
    this.track = this.audioCtx.createMediaElementSource(this.audio)

    this.track.connect(this.audioCtx.destination)

    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.playPauseBtn = this.el.querySelector('.js-player-toggle')
    this.progressBar = this.el.querySelector('.js-player-progress')
    this.transcriptBtn = this.el.querySelector('.js-player-transcript')
    this.transcriptPopup = this.el.querySelector('.js-player-transcript-popup')
    this.transcriptClose = this.el.querySelector('.js-player-transcript-close')
    this.transcriptContent = this.el.querySelector('.js-player-transcript-content')
  }

  bindEvents() {
    this.playPauseBtn.addEventListener('click', this.togglePlay.bind(this), false);
    this.progressBar.addEventListener('input', (e) => this.seekTo(this.progressBar.value), false);
    this.audio.addEventListener('loadedmetadata', this.onLoadMetaData.bind(this))
    this.audio.addEventListener('error', this.onError.bind(this))
    this.audio.addEventListener('timeupdate', this.onTimeUpdate.bind(this))
    this.audio.addEventListener('ended', this.onEnded.bind(this))
    this.audio.addEventListener('pause', this.onPause.bind(this))
    this.audio.addEventListener('play', this.onPlay.bind(this))
    if(this.transcriptBtn && this.transcriptPopup && this.transcriptContent) {
      this.transcriptBtn.addEventListener('click', this.toggleTranscript.bind(this), false)
    }
    if(this.transcriptClose && this.transcriptPopup) {
      this.transcriptClose.addEventListener('click', this.closeTranscript.bind(this), false)
    }
  }

  onPlay() {
    this.playing = true;
    const playPauseButton = this.playPauseBtn.querySelector('.icon');
    playPauseButton.attributes.d.value = 'M0 0h6v24H0zM12 0h6v24h-6z';
    this.playPauseBtn.classList.add('playing');
    this.playPauseBtn.setAttribute('aria-label', this.playPauseBtn.getAttribute('data-label-play'));
    this.playPauseBtn.classList.add('is-active');
  }

  onPause() {
    this.playing = false;
    this.audio.pause();
    const playPauseButton = this.playPauseBtn.querySelector('.icon');
    playPauseButton.attributes.d.value = 'M18 12L0 24V0';
    this.playPauseBtn.classList.remove('playing');
    this.playPauseBtn.setAttribute('aria-label', this.playPauseBtn.getAttribute('data-label-paused'));
    this.playPauseBtn.classList.remove('is-active');
  }

  onEnded() {
    this.playing = false;
    const playPauseButton = this.playPauseBtn.querySelector('.icon');
    playPauseButton.attributes.d.value = 'M18 12L0 24V0';
    this.playPauseBtn.classList.remove('playing');
    this.playPauseBtn.setAttribute('aria-label', this.playPauseBtn.getAttribute('data-label-paused'));
    this.playPauseBtn.classList.remove('is-active');
  }

  onTimeUpdate() {
    this.updateAudioTime(this.audio.currentTime);
  }

  onError(e) {
    this.playPauseBtn.disabled = true;
  }

  onLoadMetaData() {
    if(this.progressBar != null) {
        this.progressBar.max = this.audio.duration;
      }
      this.updateAudioTime();
  }

  togglePlay() {
    if (this.audioCtx.state === 'suspended') {
      this.audioCtx.resume();
    }
    
    if (this.playing) {
      return this.audio.pause();
    }
    
    return this.audio.play();
  }

  seekTo(value) {
    this.audio.currentTime = value;
  }

  getTimeString(time) {
    const secs = `${parseInt(`${time % 60}`, 10)}`.padStart(2, '0');
    const min = parseInt(`${(time / 60) % 60}`, 10);

    return `${min}:${secs}`;
  }

  updateAudioTime() {
    this.progressBar.value = this.audio.currentTime;
  }

  decodeHtmlEntities(text) {
    if (!text) return text;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  openTranscript() {
    // Cherche la transcription, le titre et le sous-titre sur le parent .player-data ou ailleurs
    let transcript = ''
    let title = ''
    let subtitle = ''
    
    // Récupérer la popin active
    const activeSlide = window.overlaylayer.ui.$overlay.querySelector('.swiper-slide-active')
    const playerData = activeSlide ? activeSlide.querySelector('.js-player-data') : null

    
    if(playerData) {
      transcript = this.decodeHtmlEntities(playerData.getAttribute('data-transcription')) || 'Transcription non disponible.'
      title = this.decodeHtmlEntities(playerData.getAttribute('data-title')) || ''
      subtitle = this.decodeHtmlEntities(playerData.getAttribute('data-subtitle')) || ''
    } else {
      transcript = 'Transcription non disponible.'
    }
    let html = ''
    if(subtitle) {
      html += `<h1 class="player-transcript-popup__subtitle">${subtitle}</h1>`
    }
    if(title) {
      html += `<h2 class="player-transcript-popup__title label-l-medium mt-8">${title}</h2>`
    }

    html += `<p class="player-transcript-popup__text  wysiwyg body-s u-ta-center">${transcript}</p>`
    this.transcriptContent.innerHTML = html
    this.transcriptPopup.hidden = false;
    this.transcriptPopup.classList.remove('animate-out');
    this.transcriptPopup.classList.add('animate-in');
    this.transcriptBtn.classList.add('is-active');
    // Désactiver le focus sur tous les éléments sauf la transcription et le player
    const container = document.querySelector('.js-overlay-ancestor');
    const allFocusableElements = container.querySelectorAll('a, button');
    allFocusableElements.forEach(el => {
      if (!el.closest('.js-player') && !el.closest('.js-player-transcript-popup')) {
        el.tabIndex = -1;
      }
    });
    const playerFocusableElements = this.transcriptPopup.querySelectorAll('button');
    const allFocusableElementsInScope = playerFocusableElements
    allFocusableElementsInScope.forEach(el => {
      el.tabIndex = 0;
    });
    
    // Gérer les événements de clavier pour la transcription
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        this.closeTranscript();
      }
      if (e.key === 'Tab') {
        const currentIndex = Array.from(allFocusableElementsInScope).indexOf(document.activeElement);
        
        if (e.shiftKey) {
          // Tab inversé (Shift + Tab)
          if (currentIndex === 0) {
            e.preventDefault();
            allFocusableElementsInScope[allFocusableElementsInScope.length - 1].focus();
          }
        } else {
          // Tab normal
          if (currentIndex === allFocusableElementsInScope.length - 1) {
            e.preventDefault();
            allFocusableElementsInScope[0].focus();
          }
        }
      }
    };

    this.transcriptPopup.addEventListener('keydown', handleKeyDown);
    this.el.addEventListener('keydown', handleKeyDown);

    // Sauvegarder la référence à la fonction pour le nettoyage
    this._transcriptKeyDownHandler = handleKeyDown;

    // Mettre le focus sur le premier élément focusable
    const firstFocusableElement = this.transcriptPopup.querySelector('button');
    if (firstFocusableElement) {
      firstFocusableElement.focus();
    }
  }

  toggleTranscript() {
    if (this.transcriptPopup && !this.transcriptPopup.hidden) {
      this.closeTranscript()
    } else {
      this.openTranscript()
    }
  }

  closeTranscript() {
    this.transcriptBtn.classList.remove('is-active');
    this.transcriptPopup.classList.remove('animate-in');
    this.transcriptPopup.classList.add('animate-out');
    
    // Supprimer les gestionnaires d'événements
    if (this._transcriptKeyDownHandler) {
      this.transcriptPopup.removeEventListener('keydown', this._transcriptKeyDownHandler);
      this.el.removeEventListener('keydown', this._transcriptKeyDownHandler);
      this._transcriptKeyDownHandler = null;
    }
    
    // Remettre les règles de focus au parent
    const container = document.querySelector('.js-overlay-ancestor');
    const allFocusableElements = container.querySelectorAll('a, button');
    allFocusableElements.forEach(el => {
      el.tabIndex = 0;
    });

    // Après la transition, on masque la popup
    const onTransitionEnd = () => {
      this.transcriptPopup.hidden = true
      this.transcriptPopup.removeEventListener('transitionend', onTransitionEnd)
      this.transcriptPopup.classList.remove('animate-out')
    }
    this.transcriptPopup.addEventListener('transitionend', onTransitionEnd)
  }

  removeAllEvents() {
    // Nettoyer les événements du bouton play/pause
    if (this.playPauseBtn) {
      const newPlayPauseBtn = this.playPauseBtn.cloneNode(true);
      this.playPauseBtn.parentNode.replaceChild(newPlayPauseBtn, this.playPauseBtn);
      this.playPauseBtn = newPlayPauseBtn;
    }

    // Nettoyer les événements de la barre de progression
    if (this.progressBar) {
      const newProgressBar = this.progressBar.cloneNode(true);
      this.progressBar.parentNode.replaceChild(newProgressBar, this.progressBar);
      this.progressBar = newProgressBar;
    }

    // Nettoyer les événements de l'audio
    if (this.audio) {
      this.audio.removeEventListener('loadedmetadata', this.onLoadMetaData.bind(this));
      this.audio.removeEventListener('error', this.onError.bind(this));
      this.audio.removeEventListener('timeupdate', this.onTimeUpdate.bind(this));
      this.audio.removeEventListener('ended', this.onEnded.bind(this));
      this.audio.removeEventListener('pause', this.onPause.bind(this));
      this.audio.removeEventListener('play', this.onPlay.bind(this));
    }

    // Nettoyer les événements de la transcription
    if (this.transcriptBtn) {
      const newTranscriptBtn = this.transcriptBtn.cloneNode(true);
      this.transcriptBtn.parentNode.replaceChild(newTranscriptBtn, this.transcriptBtn);
      this.transcriptBtn = newTranscriptBtn;
    }
    if (this.transcriptClose) {
      const newTranscriptClose = this.transcriptClose.cloneNode(true);
      this.transcriptClose.parentNode.replaceChild(newTranscriptClose, this.transcriptClose);
      this.transcriptClose = newTranscriptClose;
    }

    // Nettoyer les événements de la popup de transcription
    if (this._transcriptKeyDownHandler) {
      if (this.transcriptPopup) {
        this.transcriptPopup.removeEventListener('keydown', this._transcriptKeyDownHandler);
      }
      if (this.el) {
        this.el.removeEventListener('keydown', this._transcriptKeyDownHandler);
      }
      this._transcriptKeyDownHandler = null;
    }
  }
}

export default AudioPlayer
